const google = (window as any).google;

const service = new google.maps.places.PlacesService(document.createElement('div'));

const reviewAverage = document.querySelectorAll('.propertyInfo__reviewAverage');
if (reviewAverage.length > 0) {
	for (let i = 0; i < reviewAverage.length; i++) {
        createReviewsTotal(reviewAverage[i] as HTMLElement);
    }
}

function createReviewsTotal(element: HTMLElement) {
    const placeId = element.getAttribute('data-placeId');

    const request = { placeId, fields: ['user_ratings_total', 'rating'] };
    service.getDetails(request, (placeDetails: any, status: any) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
            const totalReviews = placeDetails.user_ratings_total;
            const averageRating = placeDetails.rating;

            let reviewDiv = document.createElement('div');
            reviewDiv.innerHTML = `
                <div class="ratingStars"> <span class="ratingAve">${averageRating.toFixed(1)}</span></div>
                <span class="numberOfReviews">${totalReviews} Google Reviews</span>
            `;

            const ratingDiv = reviewDiv.querySelector('.ratingStars');
            for (let i = 0; i < 5; i++) {
                const star = document.createElement('span');

                if (i < Math.floor(averageRating)) {
                    star.textContent = '⭐';
                    star.classList.add('star');
                } else if (i === Math.floor(averageRating) && averageRating % 1 !== 0) {
                    star.textContent = '⭐';
                    star.classList.add('star', 'star--partial');
                } else {
                    star.textContent = '☆';
                }

                ratingDiv.appendChild(star);
            }

            element.innerHTML = '';
            element.appendChild(reviewDiv);
        } else {
            throw new Error(`Error fetching place total reviews: ${status}`);
        }
    });
}

// Review Card Listing (bottom of propery pages)
const reviewListing = document.querySelectorAll('.reviews');
if (reviewListing.length > 0) {
	for (let i = 0; i < reviewListing.length; i++) {
		const reviewListingItem = reviewListing[i];
		const placeId = reviewListingItem.getAttribute('data-placeId');

		// Specify parameters
		const request = {
			placeId: placeId,
			fields: ['name', 'reviews']
		};

		// Make request
		service.getDetails(request, (place: any, status: any) => {
			if (status === google.maps.places.PlacesServiceStatus.OK) {
				// Get reviews from place result
				const reviews = place.reviews;

				// Review template
				const reviewTemplate = `
					<div class="review">
						<div class="review__intro">
							<div class="review__introHeading">
								<h4 class="author"></h4>
								<div class="rating"></div>
								<span class="description"></span>
							</div>
							<img src="" alt="">
						</div>
						<div class="review__content">
							<p class="content"></p>
						</div>
					</div>
				`;

				// Create template element
				const template = document.createElement('template');
				template.innerHTML = reviewTemplate;

				// Output reviews
				reviewListingItem.innerHTML = '';
				reviews.forEach((review: any) => {
					// Clone template
					const reviewDiv = template.content.cloneNode(true) as HTMLElement;

					// Add data
					reviewDiv.querySelector('.author').textContent = review.author_name;
					reviewDiv.querySelector('.description').textContent = '(' + review.relative_time_description + ')';
					reviewDiv.querySelector('img').src = review.profile_photo_url;
					reviewDiv.querySelector('img').alt = review.author_name;

					// Add ratings
					const ratingDiv = reviewDiv.querySelector('.rating');
					for (let i = 0; i < 5; i++) {
						if (i < review.rating) {
							const star = document.createElement('span');
							star.textContent = '⭐';
							ratingDiv.appendChild(star);
						}
					}

					// Add review content
					reviewDiv.querySelector('.content').textContent = review.text;

					// Add to DOM
					reviewListingItem.appendChild(reviewDiv);
				});
			}
		});
	}
}